import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "app-nav" }
const _hoisted_2 = { class: "app-nav-menu" }
const _hoisted_3 = { class: "app-nav-menu-item--title" }

export interface IMenuItem {
        name: string;
        path: string;
        icon?: string;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'AppNavigation',
  setup(__props) {

    // import aboutLogo from "@/assets/svg/002-about.svg";
    // import eduLogo from "@/assets/svg/004-mortarboard.svg";
    // import skillLogo from "@/assets/svg/003-selfconfident.svg";
    // import projectLogo from "@/assets/svg/001-brief.svg";
    // import puzzleLogo from "@/assets/svg/005-puzzle.svg";

    const menu: IMenuItem[] = [
        {
            name: "About me",
            path: "/about",
            icon: "info-circle",
        },
        {
            name: "Education",
            path: "/education",
            icon: "book-open",
        },
        {
            name: "Skills",
            path: "/skills",
            icon: "lightbulb",
        },
        {
            name: "Projects",
            path: "/projects",
            icon: "tasks",
        },
        {
            name: "Other stuffs",
            path: "/other-stuffs",
            icon: "puzzle-piece",
        },
    ];

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menu, (item) => {
        return _createVNode(_component_router_link, {
          to: item.path,
          class: "app-nav-menu-item",
          "active-class": "active",
          key: item.path
        }, {
          default: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass('fa fa-' + item.icon)
            }, null, 2),
            _createElementVNode("strong", _hoisted_3, _toDisplayString(item.name), 1)
          ]),
          _: 2
        }, 1032, ["to"])
      }), 64))
    ])
  ]))
}
}

})